module.exports = __webpack_public_path__ + "static/media/logo_h.f8600d47.svg";